import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { createRoute } from 'lib/util';
import * as Common from 'common/components';
const { Form } = Common;

class AssetsListHeader extends PureComponent {
  static propTypes = {
    canAdd: PropTypes.bool,
    companyId: PropTypes.string.isRequired,
    subcompanyId: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    canAdd: false,
  };

  render = () => (
    <Common.Header title={this.props.t('import.title')}>
      <div className="btn-group pull-right">
        {this.props.canAdd && (
          <Form.Link
            to={createRoute(this.props.companyId, this.props.subcompanyId, 'import/add')}
            className="btn btn-info"
          >
            {this.props.t('actions.add')}
          </Form.Link>
        )}
      </div>
    </Common.Header>
  );
}

export default translate()(AssetsListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/components/list/ImportListHeader.js